export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/plus-20de626f5601aef79f57d0bf25637ba2.svg";